
angular.module('bmsApp.directives')
		.directive('licenseSelection', function () {
			return {
				restrict: 'E',
				require: 'ngModel',
				scope: {
					ngModel: '=',
					licenses: '=',
					includeFormGroup: '='
				},
				replace: true,
				templateUrl: 'ng/shared/directives/stack0/licenseSelection/licenseSelection.html',
				link: function(scope, element, attrs){

//					var licenses = scope.$eval(attrs.licenses);
					
					scope.$watch('licenses', function(value){
						if (angular.isDefined(value)){
							scope.singleLicense = (value.length <=1) ? true : false;
							if (angular.isObject(scope.ngModel) !== true) {
								scope.ngModel = scope.licenses[0];
							}
						}
					});
				}
			};
		});

